import styled from "styled-components";

export const HeroSection = styled.div`
  width: calc(100vw - 80px);
  max-width: 2560px;
  height: 600px;
  // background-color: #1983ff;
  background-image: url("/images/hero-background.webp");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  border-radius: 20px;
  align-items: center;
  text-align: center;

  @media (max-width: 1920px) {
    width: calc(100vw - 60px);
    height: 500px;
  }

  @media (max-width: 1440px) {
    width: calc(100vw - 50px);
    height: 450px;
  }

  @media (max-width: 1024px) {
    width: calc(100vw - 40px);
    height: 400px;
  }

  @media (max-width: 768px) {
    width: calc(100vw - 30px);
    height: 350px;
    justify-content: center;
  }

  @media (max-width: 480px) {
    width: calc(100vw - 20px);
    height: 300px;
  }
`;

export const HeroText = styled.h1`
  color: black;
  font-size: 48px;
  font-weight: 800;
  line-height: 1.4;
  margin-top: 100px;
  margin-bottom: 40px;
  white-space: pre-line;

  @media (max-width: 1920px) {
    font-size: 42px;
    margin-top: 80px;
  }

  @media (max-width: 1440px) {
    font-size: 36px;
    margin-top: 60px;
  }

  @media (max-width: 1024px) {
    font-size: 32px;
    margin-top: 50px;
  }

  @media (max-width: 768px) {
    font-size: 28px;
    line-height: 1.3;
    margin-bottom: 24px;
    // padding: 0 10px;
  }

  @media (max-width: 480px) {
    font-size: 24px;
    margin-top: 40px;
  }
`;

export const StartButton = styled.button`
  background-color: #000;
  color: white;
  padding: 15px 40px;
  border: none;
  border-radius: 8px;
  font-size: 20px;
  font-weight: 700;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #333;
  }

  @media (max-width: 1920px) {
    padding: 14px 36px;
    font-size: 18px;
  }

  @media (max-width: 1440px) {
    padding: 13px 32px;
    font-size: 17px;
  }

  @media (max-width: 1024px) {
    padding: 12px 30px;
    font-size: 16px;
  }

  @media (max-width: 768px) {
    padding: 12px 28px;
    font-size: 16px;
  }

  @media (max-width: 480px) {
    padding: 10px 25px;
    font-size: 14px;
  }
`;
